var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.28571 6.78007C9.28571 6.58594 9.4386 6.42857 9.6462 6.42857H10.3538C10.5529 6.42857 10.7143 6.58312 10.7143 6.78007V11.4342C10.7143 11.6283 10.5614 11.7857 10.3538 11.7857H9.6462C9.44711 11.7857 9.28571 11.6312 9.28571 11.4342V6.78007ZM9.28571 13.2176C9.28571 13.0185 9.4386 12.8571 9.6462 12.8571H10.3538C10.5529 12.8571 10.7143 13.01 10.7143 13.2176V13.9252C10.7143 14.1243 10.5614 14.2857 10.3538 14.2857H9.6462C9.44711 14.2857 9.28571 14.1328 9.28571 13.9252V13.2176ZM10 18.5714C14.7339 18.5714 18.5714 14.7339 18.5714 10C18.5714 5.26613 14.7339 1.42857 10 1.42857C5.26613 1.42857 1.42857 5.26613 1.42857 10C1.42857 14.7339 5.26613 18.5714 10 18.5714Z",
    fill: "#997404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTick);
export default __webpack_public_path__ + "static/media/WarningTick.27b4cd42a8cbca2e13b299668913baa4.svg";
export { ForwardRef as ReactComponent };